import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  DataResponse,
  GetBackofficeSupportDomainActivitySchema,
  GetDeflectionActivityResponseDataSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetBackofficeSupportDomainActivitySchema>
type Response = DataResponse<z.infer<typeof GetDeflectionActivityResponseDataSchema>>

type Props = {
  query: Query
  enabled?: boolean
}

export const getBackofficeSupportDomainActivityQuery = ({ query, enabled = true }: Props) =>
  queryOptions({
    queryKey: ["backofficeSupportDomainActivity", query],
    queryFn: async () => {
      const { data } = await axios.get<Response>("/backoffice/support/domain-activity", {
        params: query,
      })
      return data.data
    },
    enabled,
  })
